
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MobileNav',
  methods: {
    triggerExpand() {
      this.$root.$emit('ui:show-sidebar-menu')
    }
  }
})
